export default __webpack_public_path__ + "static/media/ad.9b91ac0d.svg";